import { end } from 'perf-marks';
export var createClosedEvent = function createClosedEvent(input) {
  return {
    eventType: 'ui',
    action: 'closed',
    actionSubject: 'mediaViewer',
    attributes: {
      sessionDurationMs: end('MediaViewer.SessionDuration').duration || 0,
      input: input
    }
  };
};